module.exports = {"140902001":"秀容街道","140902002":"长征街街道","140902003":"新建路街道","140902100":"播明镇","140902101":"奇村镇","140902102":"三交镇","140902103":"庄磨镇","140902104":"豆罗镇","140902105":"董村镇","140902200":"曹张乡","140902201":"高城乡","140902202":"秦城乡","140902203":"解原乡","140902204":"合索乡","140902205":"阳坡乡","140902206":"兰村乡","140902207":"紫岩乡","140902208":"西张乡","140902209":"东楼乡","140902210":"北义井乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140902.json
// module id = 346
// module chunks = 0